import * as yup from 'yup';
import svStrings from '../../../sv-strings';
import { Field, FIELD_TYPES, OptionsGroup, UIschema } from '../../../types';
import { Article, Author } from './types';
import moment from 'moment';

export const getArticleSchema = (
  appConfigs: OptionsGroup[],
  authors: Author[],
  article: Article
): UIschema => ({
  name: 'Edit article',
  fields: [
    {
      id: 'title',
      type: FIELD_TYPES.TEXT,
      key: 'title',
      value: article.title,
      title: svStrings.faq.fieldNameTitle,
      validation: yup.string().required(svStrings.articles.titleFieldRequired),
    },
    {
      id: 'description',
      type: FIELD_TYPES.TEXT,
      key: 'description',
      value: article.description,
      title: svStrings.articles.fieldNameDescription,
    },
    {
      id: 'appAbbrvs',
      type: FIELD_TYPES.MULTI_SELECT,
      key: 'appAbbrvs',
      value: article.apps?.map((t) => t.abbrv) || [],
      title: svStrings.articles.fieldNameAppAbbrvs,
      groupedOptions: appConfigs,
      validation: yup.array().min(1, svStrings.articles.abbrvsRequired),
    },
    {
      id: 'publishedAt',
      type: FIELD_TYPES.DATETIME,
      key: 'publishedAt',
      value: article.publishedAt ? moment(article.publishedAt).format('YYYY-MM-DDTHH:mm') : null,
      title: svStrings.articles.fieldNamePublishedAt,
      validation: yup.date().nullable(),
    },
    // {
    //   id: 'pushNotification',
    //   type: FIELD_TYPES.SWITCH,
    //   key: 'publishedAt',
    //   value: article.pushNotification || false,
    //   title: svStrings.articles.fieldNamePushNotification,
    // },
    {
      id: 'archivedAt',
      type: FIELD_TYPES.DATETIME,
      key: 'archivedAt',
      value: article.archivedAt ? moment(article.archivedAt).format('YYYY-MM-DDTHH:mm') : null,
      title: svStrings.articles.fieldNameArchivedAt,
      validation: yup.date().nullable(),
    },
    {
      id: 'authorIds',
      type: FIELD_TYPES.MULTI_SELECT,
      key: 'authorIds',
      value: article.authors?.map((author) => author.id) || [],
      title: svStrings.articles.fieldNameAuthors,
      options: authors.map((author) => author.id),
      optionsText: authors.map((author) => `${author.name} (${author.email})`),
    },
    {
      id: 'imageUrl',
      type: FIELD_TYPES.IMAGE,
      key: 'imageUrl',
      value: article.imageUrl,
      title: svStrings.articles.fieldNameImage,
      validation: yup.string().url(svStrings.validations.validImage),
    },
    {
      id: 'excerpt',
      type: FIELD_TYPES.TEXT,
      key: 'excerpt',
      value: article.excerpt,
      title: svStrings.articles.fieldNameExcerpt,
      numRows: 3,
    },
    {
      id: 'content',
      type: FIELD_TYPES.RICH_TEXT,
      key: 'content',
      value: article.content,
      title: svStrings.articles.fieldNameContent,
    },
  ] as Field[],
});

export const getAuthorSchema = (appConfigOptions: OptionsGroup[], author: Author): UIschema => ({
  name: 'Edit author',
  fields: [
    {
      id: 'name',
      type: FIELD_TYPES.TEXT,
      key: 'name',
      value: author.name,
      title: svStrings.articles.fieldNameAuthorName,
      validation: yup.string().required(svStrings.articles.authorNameRequired),
    },
    {
      id: 'email',
      type: FIELD_TYPES.TEXT,
      key: 'email',
      value: author.email,
      title: svStrings.articles.fieldNameAuthorEmail,
      validation: yup
        .string()
        .email(svStrings.validations.validEmail)
        .required(svStrings.articles.authorEmailRequired),
    },
    {
      id: 'appAbbrvs',
      type: FIELD_TYPES.MULTI_SELECT,
      key: 'appAbbrvs',
      value: author.apps?.map((t) => t.abbrv) || [],
      title: svStrings.articles.fieldNameAppAbbrvs,
      groupedOptions: appConfigOptions,
      validation: yup.array().min(1, svStrings.articles.abbrvsRequired),
    },
    {
      id: 'imageUrl',
      type: FIELD_TYPES.IMAGE,
      key: 'imageUrl',
      value: author.imageUrl,
      title: svStrings.articles.fieldNameAuthorImage,
      validation: yup.string().url(svStrings.validations.validImage),
    },
  ] as Field[],
});
